import styled from '@benzinga/themetron';

export const AlternativeCard = ({ body, error = '', handleClick, icon, label, rbgColor, title }) => {
  return (
    <AltCardContainer color={rbgColor}>
      <div className="w-1/5">{icon}</div>
      <div className="w-4/5">
        <div className="font-bold">{title}</div>
        <p className="text-xs m-0">{body}</p>
        <button className="mt-2 text-xs" onClick={handleClick}>
          {label}
        </button>
        {error && <div className="text-red-500 text-sm">{error}</div>}
      </div>
    </AltCardContainer>
  );
};

const AltCardContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0.5rem;
  border-left: 0.5rem solid rgba(${props => props.color}, 0.8);
  font-size: 0.875rem;
  border-radius: 0.25rem;
  background-color: rgba(${props => props.color}, 0.1);

  button {
    background-color: rgba(${props => props.color}, 0.8);
    color: white;
    border: none;
    padding: 0.25rem 0.5rem;
    border-radius: 0.25rem;
  }
`;
